export default __webpack_public_path__ + "static/media/Cotton.717543db.png";